import { createContext, useState, useEffect, useContext } from "react";

import { supabase } from "../utils/supabaseClient";


const AuthContext = createContext(null);

export const AutProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const session = supabase.auth.session();
        setUser((session && session?.user) ?? null);
        setLoading(false);
        const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
            setUser((session && session?.user) ?? null);
            setLoading(false)
        });

        return () => {
            listener.unsubscribe();
        }
    }, []);
    const value = {
        signUp: async (data) => await supabase.auth.signUp(data),
        signIn: async (data) => await supabase.auth.signIn(data),
        signOut: async () => await supabase.auth.signOut(),

    };

    return (<AuthContext.Provider value={value}>
        {!loading && children}
    </AuthContext.Provider>);
};

export const useAuth = () => {
    return useContext(AuthContext);
}

